import $ from 'jquery';
import 'jquery.easing';
import 'jquery.scrollto/jquery.scrollTo.min';

export default (element, callback = () => {}) => {
  event && event.preventDefault();
  const offset = window.innerWidth > 1040 ? 50 : 25;
  $(window).animate(
    {
      scrollTop: $(element).offset().top - offset
    },
    600,
    'swing'
  );
};
